// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_av-2";
export var aiChatCartContainerExit = "_av-4";
export var aiChatContainerLarge = "_av-0";
export var aiChatContainerSmall = "_av-1";
export var aiChatIcon = "_av-6";
export var slideInFromRight = "_av-3";
export var slideOutToRight = "_av-5";